export default {
  options: ({ list }) => list.map(item => ({
    value: item.channel_id,
    label: item.channel_title,
  })),
  hasLevelPrice: ({ list }) => list.filter(item => item.has_price_level).map(item => item.channel_id),
}
